import { Parallax } from "react-parallax";
import { Button, Content } from "../../AppStyle";
import bgImage from "../../assets/images/contact_two.jpg";
import { useRef, useState } from "react";
import emailjs from "emailjs-com";
import {
  ContactTitle,
  ContactTitleGroup,
  ContactTitleTwo,
} from "./ContactStyle";
import Modal from "react-modal";
import pbLogo from "../../assets/images/p_b_logo.png";

const Contact = () => {
  return (
    <Parallax bgImage={bgImage} bgImageAlt="the cat" strength={500}>
      <Content>
        <div
          className="responsive-contact"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: 40,
            color: "#ffffff",
            textShadow: "2px 2px 5px rgba(0,0,0,0.5)",
          }}
        >
          <h3 style={{ margin: 0, fontWeight: 700 }}>
            NEED CABINETS OR FUNITURE BUILT?
          </h3>
          <h4 style={{ marginTop: 20, marginBottom: 20, fontWeight: 500 }}>
            Call Us Today: (801) 725-1469
          </h4>
          <h4 style={{ margin: 0, fontWeight: 500 }}>
            Email: ashbycustomdesigns@gmail.com
          </h4>
        </div>
        <ContactUs />
      </Content>
    </Parallax>
  );
};

const ContactUs = () => {
  const [isModal, setIsModal] = useState(false);
  const form: any = useRef();

  const customStyles: any = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#ffffff",
      padding: 40,
      borderRadius: 5,
    },
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      zIndex: 1000,
    },
  };

  const sendEmail = (e: any) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "pb-service",
        "pb-template",
        form.current,
        "user_FLHBRJsIG3yyUO1b8QgB1"
      )
      .then(
        (result: any) => {
          console.log(result.text);
          setIsModal(true);
          e.target.reset();
        },
        (error: any) => {
          console.log(error.text);
        }
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <ContactTitleGroup>
        <ContactTitle>Contact</ContactTitle>
        <ContactTitleTwo>&nbsp;Us</ContactTitleTwo>
      </ContactTitleGroup>
      <label>Name</label>
      <input type="text" name="name" required />
      <label>Email</label>
      <input type="email" name="email" required />
      <label>Message</label>
      <textarea name="message" required />
      <input id="review" type="submit" value="SUBMIT" />
      <Modal
        closeTimeoutMS={300}
        isOpen={isModal}
        ariaHideApp={false}
        onRequestClose={() => setIsModal(false)}
        style={customStyles}
      >
        <div style={{ textAlign: "center" }}>
          <img
            style={{ width: 200, margin: "10px 0px" }}
            src={pbLogo}
            alt="PB Logo"
          />
          <h3 style={{ margin: "20px 0px", color: "#951211", fontWeight: 700 }}>
            THANK YOU FOR CONTACTING US!
          </h3>
          <h5 style={{ margin: "20px 0px" }}>
            You'll recieve your first email within the next 24 hours.
          </h5>
          <h5 style={{ margin: "10px 0px", fontWeight: 500 }}>
            If you have any other questions feel free to contact us at (801)
            725-1469.
          </h5>
          <Button onClick={() => setIsModal(false)}>CLOSE</Button>
        </div>
      </Modal>
    </form>
  );
};

export default Contact;
